// index.js
import React from "react";
import ReactDOM from "react-dom";
import { FluentProvider, webLightTheme } from '@fluentui/react-components';

import App from "./App";

import { loadTheme } from "@fluentui/react";
import { initializeIcons } from "@uifabric/icons";
import { BrowserRouter } from "react-router-dom";
import { msalInstance } from "./auth/authClient";
import { MsalProvider } from "@azure/msal-react";
import { configure } from "axios-hooks";
import { axiosInstance } from "./api/config";
import myTheme from "./theme";
import "bootstrap/dist/css/bootstrap.min.css";
import "./appInsights";

//Add your custom themes here!
initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20240805.001/assets/icons/');
configure({
  axios: axiosInstance,
  defaultOptions: { manual: false, useCache: false, ssr: false },
});

loadTheme(myTheme);

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter>
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    </BrowserRouter>
  </MsalProvider>,

  document.getElementById("root")
);
